// extracted by mini-css-extract-plugin
export default {"box":"Projects_box__8ZnU-","container":"Projects_container__LxOv1","header":"Projects_header__NXTN7"};